(() => {
  const pending = new Map();
  let queue = Promise.resolve();
  let navigating = false;

  async function persist(form) {
    if (!pending.has(form)) return;
    const status = form.querySelector('[data-iam-tag-status]');
    const properties = {};
    for (const [name, value] of new FormData(form)) {
      if (name.startsWith('properties[')) properties[name.slice(11, -1)] = value;
    }
    const key = form.elements.namedItem('id').value;
    status.textContent = 'Saving gift details…';
    const response = await fetch(form.action + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, properties })
    });
    if (!response.ok) throw new Error('Save failed');
    const cart = await response.json();
    const updated = cart.items.find(item =>
      String(item.variant_id) === key.split(':')[0] &&
      Object.entries(properties).every(([name, value]) => (item.properties?.[name] || '') === value)
    );
    if (!updated) throw new Error('Save not confirmed');
    document.querySelectorAll('[data-iam-box-key]').forEach(input => {
      if (input.value === key) input.value = updated.key;
    });
    const data = new FormData(form);
    if (Object.entries(properties).every(([name, value]) => data.get('properties[' + name + ']') === value)) {
      clearTimeout(pending.get(form));
      pending.delete(form);
      status.textContent = 'Gift details saved.';
    }
  }

  function save(form) {
    const next = queue.then(() => persist(form));
    queue = next.catch(() => {
      form.querySelector('[data-iam-tag-status]').textContent = 'Your changes haven’t saved. Tap Save gift details to try again.';
    });
    return next;
  }

  async function finish(action) {
    if (navigating) return;
    navigating = true;
    try {
      while (pending.size) await save(pending.keys().next().value);
      action();
    } catch {
      const form = pending.keys().next().value;
      if (form) form.querySelector('button').focus();
    } finally { navigating = false; }
  }

  document.addEventListener('input', event => {
    const form = event.target.closest('[data-iam-tag-form]');
    if (!form) return;
    clearTimeout(pending.get(form));
    pending.set(form, setTimeout(() => save(form).catch(() => {}), 350));
    form.querySelector('[data-iam-tag-status]').textContent = 'Saving gift details…';
  });

  document.addEventListener('change', event => {
    const box = event.target.closest('[data-iam-box-toggle]');
    if (!box) return;
    box.disabled = true;
    finish(() => box.form.requestSubmit()).finally(() => { box.disabled = false; });
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-iam-tag-form]')) {
      event.preventDefault();
      if (!pending.has(form)) pending.set(form, 0);
      save(form).catch(() => {});
    } else if (pending.size) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = event.submitter;
      finish(() => button ? form.requestSubmit(button) : form.requestSubmit());
    }
  }, true);

  document.addEventListener('click', event => {
    if (!pending.size) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || !/^https?:$/.test(link.protocol)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    finish(() => location.assign(link.href));
  }, true);
})();